import { useCoreStateContext,useCoreContext } from 'spark-core-dx/contexts';
import { useCoreRoute } from 'spark-core-dx/hooks';
import ReportManager from '../managers/convoke/ReportManager';

export function useCustomManager(itemService, isWarning = true) {
    const coreContext = useCoreContext();
    const coreState = useCoreStateContext();
    const { currentRoute } = useCoreRoute();
    const itemServiceName = itemService ?? currentRoute?.ItemName
    try {
        if (itemServiceName) {
            return new ReportManager(coreContext, coreState, isWarning)
        } else {
            return null;
        }
    }
    catch (ex) {
        coreContext.error({ status: 500, errorCode: "JSE02", statusMessage: "An error has occured.", message: ex.stack })
    }
}
